export enum NewsPageViewType {
  Cards = 'table',
  Grid = 'list',
}
